import { render, staticRenderFns } from "./dealer2statistics.vue?vue&type=template&id=0ef7404d&"
import script from "./dealer2statistics.vue?vue&type=script&lang=js&"
export * from "./dealer2statistics.vue?vue&type=script&lang=js&"
import style0 from "./dealer2statistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports